import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'
import { isHawaiiTime } from '../../utils/app-helpers'

const { siteMetadata: config } = GatsbyConfig

export default class SoldOutBar extends React.Component {
  render() {
    const { trip } = this.props
    const tripData = config.trips[trip]
    const { soldOut } = tripData
    const percent = isHawaiiTime()
      ? tripData.soldOutPercentHawaii
      : soldOut ? 100 : tripData.soldOutPercent

    return (
      <div className="sold-out-bar">
        <div className="wrap">
          {percent && percent < 100 ? (
            <p>{`Already ${percent}% SOLD OUT`}</p>
          ) : (
            ''
          )}
          {percent === 100 ? <p>SOLD OUT</p> : ''}
          {!percent ? (
            <p>
              The Ultimate Christian<br /> Couples Getaway
            </p>
          ) : (
            ''
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/sold-out-bar.js